import ApiClient from "../helpers/ApiClient";

const getFaturamento = (cnpj, params) =>
  ApiClient.apiClientDef.get(`/empresa/${cnpj}/faturamento`, { params });

const putFaturamento = (cnpj, data) =>
  ApiClient.apiClientDef.put(`/empresa/${cnpj}/faturamento`, data);

const FaturamentoApiClient = {
  getFaturamento,
  putFaturamento,
};
export default FaturamentoApiClient;
